(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ws_discount"] && !Shopify.designMode) return;
  try {
    const finalSaleBlocks = document.querySelectorAll('[data-final-sale-countdown]');

  function getEasternTimeOffsetInMs() {
    const now = new Date();

    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).formatToParts(now);

    let y = '1970';
    let m = '01';
    let d = '01';
  
  let h = '00';
    let min = '00';
    let s = '00';

    for (const part of parts) {
      if (part.type === 'year') y = part.value;
      if (part.type === 'month') m = part.value;
      if (part.type === 'day') d = part.value;
      if (part.type === 'hour') h = part.value;
      if (part.type === 'minute') min = part.value;
      if (part.type === 'second') s = part.value;
    }

    const easternNow = new Date(`${y}-${m}-${d}T${h}:${min}:${s}-05:00`);

    const midnightEastern = new Date(easternNow.getTime());
    midnightEastern.setHours(24, 0, 0, 0);

    return midnightEastern.getTime() - easternNow.getTime();
  }

  function startFinalSaleCountdown(root) {
    const timerEl = root.querySelector('[data-final-sale-countdown-timer]');
    if (!timerEl) return;

    function update() {
      const remaining = getEasternTimeOffsetInMs();

      if (remaining <= 0) {
        timerEl.textContent = '00:00:00';
        return;
      }

      const hours = String(Math.floor(remaining / (1000 * 60 * 60))).padStart(2, '0');
      const minutes = String(Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0');
      const seconds = String(Math.floor((remaining % (1000 * 60)) / 1000)).padStart(2, '0');

      timerEl.textContent = `${hours}:${minutes}:${seconds}`;
    }

    update();
    setInterval(update, 1000);
  }

  if (finalSaleBlocks && finalSaleBlocks.length) {
    finalSaleBlocks.forEach(startFinalSaleCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
